import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getConsent, setConsent, clearUserCookie } from "../utils/userCookie";
import { clearGACookies } from "../utils/analytics";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const c = getConsent();
    if (c === "accepted") {
      if (typeof window !== "undefined") {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: "cookie_consent_accepted" });
      }
      setVisible(false);
    } else if (c === "declined") {
      // If previously declined, keep GA off and do not show banner again
      clearGACookies();
      setVisible(false);
    } else {
      // No consent recorded yet
      clearGACookies();
      setVisible(true);
    }
  }, []);

  const onAccept = () => {
    setConsent("accepted");
    if (typeof window !== "undefined") {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: "cookie_consent_accepted" });
    }
    setVisible(false);
  };

  const onDecline = () => {
    setConsent("declined");
    clearUserCookie();
    clearGACookies();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 z-50 max-w-xl bg-[#1D2B53] text-white p-4 md:p-5 rounded-lg shadow-lg border border-white/20">
      <div className="text-sm mb-3">
        We use cookies to enhance your experience and store your contact details
        if you submit forms. We ensure your data privacy and security.
      </div>
      <div className="flex flex-wrap items-center gap-3">
        <button
          type="button"
          onClick={onAccept}
          className="bg-[#375AFF] hover:bg-[#2746D2] text-white text-sm font-medium px-4 py-2 rounded"
        >
          Allow
        </button>
        <button
          type="button"
          onClick={onDecline}
          className="border border-white/30 text-white text-sm font-medium px-4 py-2 rounded hover:bg-white/10"
        >
          Decline
        </button>
        <Link
          to="/privacy-policy"
          className="underline text-sm hover:text-gray-200"
        >
          Privacy Policy
        </Link>
      </div>
    </div>
  );
};

export default CookieConsent;
